import React from "react";
import { Doughnut } from "react-chartjs-2";

import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend
} from "chart.js";

import ChartDataLabels from "chartjs-plugin-datalabels";

import styles from "./PieChartCard.module.css";

// Register required chart elements
ChartJS.register(ArcElement, Tooltip, Legend, ChartDataLabels);

export default function PieChartCard({ pieData }) {
  return (
    <div className={styles.chartCard}>
      <h2 className={styles.title}>Summary Chart</h2>

      <div className={styles.chartWrapper}>
        <Doughnut
          data={pieData}
          options={{
            responsive: true,
            maintainAspectRatio: false,
            cutout: "60%", // THIS makes it a doughnut

            plugins: {
              datalabels: {
                color: "#fff",
                font: { weight: "bold", size: 14 },
                formatter: (value, ctx) => {
                  const total = ctx.chart._metasets[0].total;
                  return ((value / total) * 100).toFixed(1) + "%";
                }
              },
              legend: {
                labels: { color: "#fff" }
              }
            }
          }}
        />
      </div>
    </div>
  );
}
